export const DOMAIN = window.location.hostname.replace(/^www\./, "");
export const BASE_URL = "https://dev.teleforce.cx/api/shop/v1";

export const LEAD_API = "https://dev.teleforce.cx/api/v1/api";